import React from 'react';
import { useTranslation } from 'react-i18next';

const GConnect: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h1>{t('hyconnect')}</h1>
      <p>HYconnect page...</p>
    </div>
  );
};

export default GConnect;